export default __webpack_public_path__ + "static/media/arrow.a609638e.svg";